// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"764":"537a11b5","787":"00d9e4bf"}[chunkId] + ".chunk.js";
};